export default __webpack_public_path__ + "locales/vi/ChangePortalOwner.json?hash=4887f984cb055dc047d6e847e44be70a";